import React from "react";
import parse from "html-react-parser";

import './intro_paragraph_contents.scss';

const IntroParagraphContents = ({sectionContent}) => {

return (
<div className="intro-paragraph-content">
    {parse(sectionContent)}
</div>
)
}

export default IntroParagraphContents; 